module.exports = __webpack_public_path__ + "node_modules/ae-base/Resources/fonts/Symbola/Symbola.ttf";